// eslint-disable-next-line
import { useCallback, useState } from "react";
import { API } from "aws-amplify";
import { useLoginUser } from "../hooks/providers/useLoginUserProvider";
import { useUser } from "../hooks/useUser";

// 操作ログ関連
export const useOpelog = () => {
  const { loginUser } = useLoginUser();
  const { refreshToken } = useUser();
  const [ executing, setExecuting ] = useState(false);
  const [ errObj, setErrObj ] = useState(null);
  const [ opeErrMes ] = useState("");

  const OutputOpelog = useCallback(async(functionName: string, operationId: string, result: string) => {
    setExecuting(true);

    const apiName = "BackendApi";
    const path = "/opelog/opelog_output ";

    const option = {
      headers: {
        'X-NecAuth-Token': await refreshToken()
      },
      body: {
        result: result,
        functionName: functionName,
        operationId: operationId,
        userName: loginUser.username,
      }
    };
    loginUser.envType === 'DEV' && console.log("opelog_output_option", option);

    (async() => {
      await API.post(apiName, path, option)
      .then(async(res) => {
        loginUser.envType === 'DEV' && console.log("opelog_output_res", res);
      })
      .catch((err) => {
        setErrObj(err);
      })
      .finally(() => {
        setExecuting(false);
      });
    })();
  }, []);
  
  return {
    OutputOpelog,
    executing,
    setExecuting,
    errObj,
    opeErrMes,
  };
};
